import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CellInfo } from 'react-table';

import {
  deleteOrganizationRequest,
  getOrganizationListRequest,
  resetCurrentOrganization,
  setOrganizationListDirty,
} from '../../store/modules/organizations/actions';
import { selectOrganizationList } from '../../store/modules/organizations/selectors';
import { ListTable, ViewFrame } from '../../components';
import { useActionDispatcher, useTitle } from '../../hooks';
import DeleteAction from '../../components/action/DeleteAction';
import AdvancedActionCell from '../../components/action-cell/AdvancedActionCell';

const title = 'Organizations';

const OrganizationList = () => {
  useTitle(title);
  const dispatch = useDispatch();

  const { loading, data, dirty } = useSelector(selectOrganizationList);

  useEffect(() => {
    dispatch(resetCurrentOrganization());
  }, [dispatch]);

  const getOrganizationList = useActionDispatcher(getOrganizationListRequest);
  const setDirty = useActionDispatcher(setOrganizationListDirty);
  const deleteOrganization = useActionDispatcher(deleteOrganizationRequest);

  return (
    <ViewFrame title={title}>
      <ListTable
        columns={[
          {
            id: 'common_name',
            Header: 'Name',
            minWidth: 200,
            maxWidth: 400,
          },
          {
            id: 'city',
            Header: 'City',
            minWidth: 80,
          },
          {
            id: 'actions',
            accessor: 'id',
            Cell: (cell: CellInfo) => (
              <AdvancedActionCell>
                {
                  cell.original.permissions.can_delete &&
                  <DeleteAction {...cell} onDelete={deleteOrganization} />
                }
              </AdvancedActionCell>
            ),
            width: 65,
            style: {
              textAlign: 'right',
            },
          },
        ]}
        loading={loading}
        data={data}
        fetch={getOrganizationList}
        dirty={Boolean(dirty)}
        setDirty={setDirty}
      />
    </ViewFrame>
  );
};

export default OrganizationList;
